export enum FulfilmentTime {
  ASAP = 'ASAP',
  LATER_TODAY = 'Later Today',
  OTHER = 'Other',
}
